import { render, staticRenderFns } from "./menuHeader.vue?vue&type=template&id=46bcf6ec&lang=pug"
import script from "./menuHeader.vue?vue&type=script&lang=coffee"
export * from "./menuHeader.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports